export { urlConstructor as url } from './urlConstructor'
export {
	parse2ApplicationDomain,
	parseAsset2ApplicationDomain,
} from './domains/domains'
